var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",attrs:{"id":"date-picker"},on:{"click":function($event){return _vm.toggleDatePicker()}}},[_c('input',{ref:"b-datepicker-inp",attrs:{"readonly":"","autocomplete":"off"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }